import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wagers-container" }
const _hoisted_2 = { class: "wagers-card desktop-only" }
const _hoisted_3 = { class: "table-container" }
const _hoisted_4 = { class: "wagers-table" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "mobile-cards mobile-only" }
const _hoisted_9 = {
  key: 0,
  class: "loading-cards"
}
const _hoisted_10 = {
  key: 1,
  class: "empty-cards"
}

import { computed } from 'vue'
import type { Transaction } from '@/stores/transactions'
import WagerCard from './WagerCard.vue'
import { formatCurrency } from '@/utils/currency'


export default /*@__PURE__*/_defineComponent({
  __name: 'TransactionsTable',
  props: {
    transactions: {},
    loading: { type: Boolean }
  },
  emits: ["view-details", "rebet"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const tableRows = computed(() => {
  return props.transactions
})

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

const handleRebet = () => {
  emit('rebet')
}

const getTotalReturn = (item: Transaction) => {
  if (item.bet_status.toLowerCase() === 'open') {
    return 'TBC'
  }
  return formatCurrency(item.total_winnings, item.currency_symbol)
}

const getStatusClass = (item: Transaction) => {
  if (item.bet_status.toLowerCase() === 'settled' && item.total_winnings === '0.00') {
    return 'settled-zero'
  }
  return ''
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "BETSLIP ID"),
              _createElementVNode("th", null, "Date"),
              _createElementVNode("th", null, "Reference"),
              _createElementVNode("th", null, "Description"),
              _createElementVNode("th", null, "Status"),
              _createElementVNode("th", null, [
                _createTextVNode("Total Bet"),
                _createElementVNode("br"),
                _createTextVNode(" Amount")
              ]),
              _createElementVNode("th", null, "Total Return"),
              _createElementVNode("th")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_5, _cache[1] || (_cache[1] = [
                  _createElementVNode("td", {
                    colspan: "8",
                    class: "loader-cell"
                  }, [
                    _createElementVNode("div", { class: "table-loader" }, [
                      _createElementVNode("span", { class: "spinner" }),
                      _createTextVNode(" Loading transactions … ")
                    ])
                  ], -1)
                ])))
              : (tableRows.value.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_6, _cache[2] || (_cache[2] = [
                    _createElementVNode("td", {
                      colspan: "8",
                      class: "empty-cell"
                    }, "No transactions found.", -1)
                  ])))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(tableRows.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id,
                      class: "transaction-row"
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, _toDisplayString(formatDate(item.created_at)), 1),
                      _createElementVNode("td", null, _toDisplayString(item.reference), 1),
                      _cache[3] || (_cache[3] = _createElementVNode("td", null, "Wager", -1)),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['status', item.bet_status.toLowerCase(), getStatusClass(item)])
                        }, _toDisplayString(item.bet_status), 3)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.currency_symbol) + " " + _toDisplayString(item.total), 1),
                      _createElementVNode("td", null, _toDisplayString(getTotalReturn(item)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "details-button",
                          onClick: _withModifiers(($event: any) => (_ctx.$emit('view-details', item)), ["stop"])
                        }, " Details ", 8, _hoisted_7)
                      ])
                    ]))
                  }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[5] || (_cache[5] = [
            _createElementVNode("div", { class: "card-loader" }, [
              _createElementVNode("span", { class: "spinner" }),
              _createTextVNode(" Loading transactions... ")
            ], -1)
          ])))
        : (tableRows.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[6] || (_cache[6] = [
              _createElementVNode("p", null, "No transactions found.", -1)
            ])))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(tableRows.value, (item) => {
              return (_openBlock(), _createBlock(WagerCard, {
                key: item.id,
                transaction: item,
                onViewDetails: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('view-details', $event))),
                onRebet: handleRebet
              }, null, 8, ["transaction"]))
            }), 128))
    ])
  ]))
}
}

})